// src/seo/HomeSEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";
import { ambulanceServices } from "../data/ambulanceServices";

export default function HomeSEO() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "Madeshwara Ambulance Services",
    "url": "https://madeshwaraambulance.com",
    "logo": "https://madeshwaraambulance.com/assets/logo.png",
    "description": "24/7 emergency and non-emergency ambulance services in Bangalore. Fast response and professional care across Karnataka.",
    "telephone": "+91 98459 74238",
    "email": "madeshwaraa@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "No.9/8, Near Swimming Pool, 1st Main Road, 1st Block East, Byrasandra, Jayanagar-560011",
      "addressLocality": "Bangalore",
      "addressRegion": "Karnataka",
      "postalCode": "560011",
      "addressCountry": "IN"
    },
    "areaServed": "Bangalore, Karnataka, India",
    "openingHours": "Mo,Tu,We,Th,Fr,Sa,Su 00:00-23:59",
    "sameAs": [
      "https://www.facebook.com/MadeshwaraAmbulance",
      "https://www.instagram.com/MadeshwaraAmbulance",
      "https://www.linkedin.com/company/madeshwara-ambulance"
    ],
    "priceRange": "₹₹",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Ambulance Services",
      "itemListElement": ambulanceServices.map((service, index) => ({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": service.title,
          "description": service.description,
          "image": `https://madeshwaraambulance.com${service.image}`
          },
        "position": index + 1
      }))
    }
  };

  return (
    <Helmet>
      <title>Madeshwara Ambulance | 24/7 Emergency Ambulance Service in Bangalore</title>
      <meta
        name="description"
        content="Madeshwara Ambulance provides 24/7 emergency and non-emergency ambulance services in Bangalore and Karnataka. Fast response, professional care."
      />
      <meta
        name="keywords"
        content="ambulance service in Bangalore, emergency ambulance, ICU ambulance, Madeshwara ambulance"
      />
      {/* Open Graph */}
      <meta property="og:title" content="Madeshwara Ambulance | 24/7 Emergency Service in Bangalore" />
      <meta property="og:description" content="Reliable and fast ambulance service available 24/7 across Bangalore. Call now for immediate response." />
      <meta property="og:image" content="/assets/og-image.jpg" />
      <meta property="og:url" content="https://madeshwaraambulance.com/" />
      <meta property="og:type" content="website" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Madeshwara Ambulance | 24/7 Emergency Service in Bangalore" />
      <meta name="twitter:description" content="Get 24/7 ambulance services in Bangalore from Madeshwara Ambulance. Fast, safe, and reliable." />
      <meta name="twitter:image" content="/assets/og-image.jpg" />
      <link rel="canonical" href="https://madeshwaraambulance.com/" />
      {/* JSON-LD */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
